import { render, staticRenderFns } from "./FactEdit.vue?vue&type=template&id=b34385ce&scoped=true&"
import script from "./FactEdit.vue?vue&type=script&lang=js&"
export * from "./FactEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34385ce",
  null
  
)

export default component.exports